import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Close menu when Escape key is pressed
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        closeMenu();
      }
    };

    if (isMenuOpen) {
      document.addEventListener("keydown", handleEscKey);
      // Prevent body scrolling when menu is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
      document.body.style.overflow = "";
    };
  }, [isMenuOpen]);

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          {/* Not a heading: each page has exactly one <h1> of its own. */}
          <Link to="/" onClick={closeMenu}>
            <span className="logo-name">Shamshersons</span>
            <span className="logo-tagline">Quality Piano Works</span>
          </Link>
        </div>

        <div className="contact-info">
          <div className="contact-item">
            <span className="label">CONTACT:</span>
            <span className="value">+91 9811020513, +91 9810427172</span>
          </div>
          <div className="contact-item">
            <span className="label">EMAIL:</span>
            <span className="value">shamshersons@yahoo.co.in</span>
          </div>
        </div>

        <button
          type="button"
          className={`mobile-menu-btn ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={isMenuOpen}
          aria-controls="primary-nav"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      {/* Overlay that appears when menu is open */}
      {isMenuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}

      <nav
        id="primary-nav"
        aria-label="Main"
        className={`nav-menu ${isMenuOpen ? "open" : ""}`}
      >
        <ul>
          <li>
            <Link to="/" onClick={closeMenu}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about-us" onClick={closeMenu}>
              About Us
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={closeMenu}>
              Services
            </Link>
          </li>
          <li>
            <Link to="/achievements" onClick={closeMenu}>
              Achievements
            </Link>
          </li>
          <li>
            <Link to="/about-pianos" onClick={closeMenu}>
              About Pianos
            </Link>
          </li>
          <li>
            <Link to="/enquiry" onClick={closeMenu}>
              Contact Us
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
